/* ==========================================================================
   KCV2 collectiepagina — gedrag

   Klein en aanvullend. Het filteren zelf doet facets.js; hier zit alleen wat
   het thema niet levert: de mobiele filterdrawer, "Toon meer" in een
   filtergroep, de raster/lijst-schakelaar en het bijwerken van de URL bij
   "Meer laden".
   ========================================================================== */

(function () {
  'use strict';

  if (window.__kcv2CollectionInit) return;
  window.__kcv2CollectionInit = true;

  var LAYOUT_KEY = 'kcv2:layout';

  /* ---------- Mobiele filterdrawer ---------- */

  var lastFocus = null;

  function drawer() {
    return document.getElementById('KCV2-Facets-Drawer');
  }

  function openDrawer() {
    var el = drawer();
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    // Eén frame wachten zodat de transitie daadwerkelijk afspeelt.
    window.requestAnimationFrame(function () {
      el.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    var close = el.querySelector('.kcv2-drawer__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    var el = drawer();
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      el.hidden = true;
    }, 220);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  /* ---------- Raster of lijst ---------- */

  function applyLayout(mode) {
    var wrap = document.getElementById('Product-Grid-Container');
    if (!wrap) return;
    wrap.setAttribute('data-layout', mode);
    document.querySelectorAll('[data-kcv2-layout]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-kcv2-layout') === mode);
    });
    try {
      window.localStorage.setItem(LAYOUT_KEY, mode);
    } catch (e) { /* private mode */ }
  }

  function restoreLayout() {
    var wrap = document.getElementById('Product-Grid-Container');
    if (!wrap) return;
    var saved = null;
    try {
      saved = window.localStorage.getItem(LAYOUT_KEY);
    } catch (e) { /* private mode */ }
    applyLayout(saved || wrap.getAttribute('data-layout') || 'grid');
  }

  /* ---------- Toon meer in een filtergroep ---------- */

  function toggleMore(btn) {
    var list = btn.parentElement && btn.parentElement.querySelector('[data-kcv2-facet-values]');
    if (!list) return;
    var collapsed = list.classList.toggle('is-collapsed');
    btn.textContent = collapsed ? btn.getAttribute('data-more') : btn.getAttribute('data-less');
  }

  /* ---------- Delegation ---------- */

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target.closest) return;

    if (target.closest('[data-kcv2-open-facets]')) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (target.closest('[data-kcv2-close-facets]') || target.closest('[data-kcv2-facets-apply]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var more = target.closest('[data-kcv2-facet-more]');
    if (more) {
      e.preventDefault();
      toggleMore(more);
      return;
    }

    var layoutBtn = target.closest('[data-kcv2-layout]');
    if (layoutBtn) {
      e.preventDefault();
      applyLayout(layoutBtn.getAttribute('data-kcv2-layout'));
      return;
    }

    /* Meer laden: de URL meeschrijven (spec T12). Zonder dit staat een
       bezoeker die op product 40 klikt en teruggaat weer bovenaan. */
    var loadMore = target.closest('.pagination-more-button');
    if (loadMore && loadMore.getAttribute('href')) {
      try {
        window.history.replaceState({}, '', loadMore.getAttribute('href'));
      } catch (err) { /* replaceState kan in een iframe geweigerd worden */ }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var el = drawer();
    if (el && !el.hidden) closeDrawer();
  });

  /* ---------- Na een filterwissel opnieuw toepassen ----------
     facets.js vervangt de volledige inhoud van #Product-Grid-Container,
     waardoor data-layout terugvalt op de serverwaarde. */

  function observe() {
    var wrap = document.getElementById('Product-Grid-Container');
    if (!wrap || !window.MutationObserver) return;

    var pending = null;
    new MutationObserver(function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(restoreLayout, 50);
    }).observe(wrap, { childList: true });
  }

  function init() {
    restoreLayout();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
